import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

interface NoteCircleScaleSelectorProps {
  minScale?: number;
  maxScale?: number;
  step?: number;
}

export const NoteCircleScaleSelector: React.FC<NoteCircleScaleSelectorProps> = ({
  minScale = 0.4,
  maxScale = 1.0,
  step = 0.05,
}) => {
  const noteCircleScale = useFretboardConfigStore((state) => state.noteCircleScale);
  const setNoteCircleScale = useFretboardConfigStore((state) => state.setNoteCircleScale);

  // Convert decimal to percentage for UI
  const percentValue = Math.round(noteCircleScale * 100);
  const minPercent = Math.round(minScale * 100);
  const maxPercent = Math.round(maxScale * 100);
  const stepPercent = Math.round(step * 100);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPercentValue = parseInt(e.target.value, 10);
    if (!isNaN(newPercentValue)) {
      // Convert percentage back to decimal for the store
      const newDecimalValue = newPercentValue / 100;
      setNoteCircleScale(newDecimalValue);
    }
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Circle Size</span>
        <span className="label-text-alt">{percentValue}%</span>
      </label>
      <div className="flex gap-3 items-center">
        <input
          type="range"
          className="range range-primary flex-grow"
          value={percentValue}
          onChange={handleChange}
          min={minPercent}
          max={maxPercent}
          step={stepPercent}
        />
        <input
          type="number"
          className="input input-bordered input-sm w-20 min-w-18"
          value={percentValue}
          onChange={handleChange}
          min={minPercent}
          max={maxPercent}
          step={stepPercent}
        />
      </div>
    </div>
  );
};
